export const waitForMinimumDuration = async <T>(
  operation: Promise<T>,
  minimumMs = 1000,
): Promise<T> => {
  const [result] = await Promise.all([
    operation,
    new Promise<void>((resolve) => globalThis.setTimeout(resolve, minimumMs)),
  ]);

  return result;
};
